<template>
  <div>
    <v-row>
      <v-col
        >Show this category if text of the parent is equal to

        <v-text-field
          v-model="existingCondition"
          hide-details
          single-line
          @input="setConditions"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    node: Object,
    parentNodeId: String,
    parentNodeName: String,
    selectedRecord: Object,
    parentRecord: Object,
    index: Number,
    prexistingCondition: String
  },
  created() {
    if (this.prexistingCondition != this.index) {
      this.existingCondition = this.prexistingCondition.trim();
      this.setConditions(this.existingCondition);
    }
  },
  data() {
    return {
      existingCondition: ""
    };
  },
  methods: {
    setConditions(condition) {
      let conditionObject = {
        condition,
        index: this.index
      };
      this.$emit("setCondition", conditionObject);
    }
  }
};
</script>

<style></style>
